<script lang="ts">
  import { ContactUsStep, contactUsForm } from '@features/contactUs/config/store';
  import { cn } from '@shared/lib';
  import { Icon } from '@shared/ui/icon';
  import SwitchStep from './switch-item.svelte';

  $: isFirstStep = $contactUsForm.step === ContactUsStep.First;
  $: isSecondStep = $contactUsForm.step === ContactUsStep.Second;

  const handlePrev = () => {
    contactUsForm.updateStep(ContactUsStep.First);
  };
</script>

<div
  class="{cn(
    'bg-grey dark:bg-dark-alt before:bg-default-320 after:bg-default-900 before:dark:bg-default-900 after:dark:bg-default-50 relative mb-5 flex flex-col overflow-hidden rounded-tl-lg rounded-tr-lg duration-1000 before:absolute before:bottom-0 before:left-0 before:right-0 before:z-10 before:h-[3px] before:w-full after:absolute after:bottom-0 after:left-0 after:right-0 after:z-20 after:h-[3px] after:-translate-x-1/2 after:transition-transform md:flex-row md:rounded-lg md:before:hidden md:after:hidden',
    {
      'after:translate-x-0': isSecondStep,
    },
  )}"
>
  <button
    class="{cn(
      'bg-default-200 text-default-500 dark:bg-dark-250 dark:text-dark-600 relative flex w-full items-center justify-between gap-3 p-3  md:w-1/2',
      {
        'bg-default-100  text-default-900 dark:bg-dark-200 dark:text-default-50': isFirstStep,
        'hidden md:flex': !isFirstStep,
      },
    )}"
    on:click="{handlePrev}"
  >
    <div class="flex items-center gap-3">
      <SwitchStep isActive="{isFirstStep}">
        <svelte:fragment slot="step">1</svelte:fragment>
        <svelte:fragment slot="text">Personal Information</svelte:fragment>
      </SwitchStep>
    </div>

    <button
      class="{cn('text-default-500 flex items-center gap-3 bg-transparent md:hidden', {
        'bg-default-100  text-default-900 dark:bg-dark-200 dark:text-default-50': isSecondStep,
        'md:hidden': !isSecondStep,
      })}"
      disabled
    >
      <SwitchStep isActive="{isSecondStep}">
        <svelte:fragment slot="step">2</svelte:fragment>
      </SwitchStep>
    </button>

    <Icon
      name="arrow-fill"
      classes="{cn(
        'absolute bottom-0 right-[1px] top-0 text-default-200 dark:text-dark-250 hidden translate-x-full md:block',
        {
          'text-default-100 dark:text-dark-200': isFirstStep,
        },
      )}"
    />
  </button>

  <div
    class="{cn(
      'bg-default-200 text-default-500 dark:bg-dark-250 flex items-center gap-3 p-3 md:w-1/2 md:px-10 md:py-3',
      {
        'bg-default-100  text-default-900 dark:bg-dark-200 dark:text-default-50': isSecondStep,
        'hidden md:flex': !isSecondStep,
      },
    )}"
  >
    <button
      class="{cn('text-default-500  dark:text-dark-600 relative flex items-center gap-3 bg-transparent md:hidden', {
        'bg-default-100 text-default-900  dark:bg-dark-200 dark:text-default-50 hidden': isFirstStep,
      })}"
      on:click="{handlePrev}"
    >
      <SwitchStep isActive="{isFirstStep}">
        <svelte:fragment slot="step">1</svelte:fragment>
      </SwitchStep>
    </button>

    <SwitchStep isActive="{isSecondStep}">
      <svelte:fragment slot="step">2</svelte:fragment>
      <svelte:fragment slot="text">Request Information</svelte:fragment>
    </SwitchStep>
  </div>
</div>
